import { Alpine as AlpineType } from 'alpinejs';

const FILTER_BUNDLE_SP_API =
  'https://apiv2.loopwork.co/bundleStorefront/filterBundleSellingPlanIds';

export default (Alpine: AlpineType) => {
  Alpine.data('LSGProductView', (props: any) => ({
    slider: null,
    selectedSellingPlanIndex: 0,
    selectedSellingPlanInId: null,
    sellingPlans: [],
    loopBundleSellingPlans: [],
    selectedSellingPlanIndexLSGPostATC:null,
    redirectToCheckout: false,
    isShowLSGPostATCModal: false,
    ...props,

    async init() {

      this.sellingPlans = this.sellingPlanGroups?.flatMap(spg => {
        return spg?.selling_plans?.map(sp => sp);
      });
      this.setSelectedSellingPlanId(
        this.defaultVariant.sellingPlanAllocations[0]?.sellingPlanId
      );


      this.setCurrentVariant(this.defaultVariant.id);

      await this.checkLoopBundleSellingPlans();


      if (!this.sellingPlanGroups || this.sellingPlanGroups.length === 0) {
        //this.enableSellingPlan = false;
      }

      if (!this.variants.length) {
        this.enableSellingPlan = false;
        this.hasSubscription = false;
      }

      if (this.isQuickview) {
        await this.$nextTick();

        this.$refs.blazeSlider
          .querySelector('.blaze-track')
          .append(
            ...this.$refs.images.querySelectorAll(
              '.product-quickview__image-container'
            )
          );

        await this.$nextTick();
      } else {
        const variantId = new URLSearchParams(location.search).get('variant');

        if (!variantId) {
          if (this.currentVariantId) {
            window.history.pushState(
              {},
              '',
              `${window.location.pathname}?variant=${this.currentVariantId}`
            );
          }
        } else {
          const parsedVariantId = parseInt(variantId);

          if (
            this.currentVariantId &&
            this.currentVariantId !== parsedVariantId &&
            this.variants.find((variant: any) => variant.id === parsedVariantId)
          ) {
            this.currentVariantId = parsedVariantId;
            this.carouselImages[0] = this.currentVariant.image;
          }
        }
      }

      const { default: BlazeSlider } = await import('blaze-slider');

      this.slider = new BlazeSlider(this.$refs.blazeSlider, {
        all: {
          loop: true,
          slidesToShow: 5,
          slideGap: '12px',
        },
      });
    },

    get currentImage() {
      return this.carouselImages[this.currentImageIndex];
    },
    get currentVariant() {
      const currentVariant = this?.variants?.length
        ? this.variants.find(
          (variant: any) => variant.id === this.currentVariantId
        )
        : this.defaultVariant;

      return currentVariant;
    },
    get currentVariantPlanAllocations() {
      const allocations = this?.currentVariant?.sellingPlanAllocations?.filter(
        (allocation: { sellingPlanId: number }) => {
          return !this.loopBundleSellingPlans.includes(
            allocation.sellingPlanId
          );
        }
      );

      return allocations;
    },
    get fullPrice() {
      return this.currentVariant.compareAtPrice;
    },
    get subscriptionPrice() {
      const price = this.currentVariant?.sellingPlanAllocations.find(
        (allocation: { sellingPlanId: number }) => {
          return allocation.sellingPlanId === this.selectedSellingPlanInId;
        }
      )?.price;


      return price;
    },
    get subscriptionServingPrice() {
      const price = this.currentVariant?.sellingPlanAllocations.find(
        (allocation: { sellingPlanId: number }) => {
          return allocation.sellingPlanId === this.selectedSellingPlanInId;
        }
      )?.servingPrice;

      return price;
    },
    get price() {
      return this.currentVariant.price;
    },
    get servingPrice() {
      return this.currentVariant.servingPrice;
    },
    get discounts() {
      return this.variants.map((variant: any) =>
        this.enableSellingPlan
          ? variant.sellingPlanAllocations[this.selectedSellingPlanIndex]
            .discount
          : variant.discount
      );
    },
    get selectedSellingPlan() {
      if (!this.sellingPlans) {
        return null;
      }
      const plan = this.sellingPlans.find(
        (sp: { id: number }) => sp.id === this.selectedSellingPlanInId
      );
      return plan || null;
    },
    get ctaText() {
      if (!this.variants.length) {
        return 'Not available';
      }

      if (this.currentVariant.available) {
        return `${
          this.enableSellingPlan
            ? this.buttonCtaTextSubscribe || 'Get Started'
            : this.buttonCtaTextOneTime || 'Try Now'
        }`;
      } else {
        return this.notAvailableButtonText;
      }
    },
    get ctaTextWithoutMoney() {
      if (!this.variants.length) {
        return 'Not available';
      }

      if (this.currentVariant.available) {
        return this.enableSellingPlan
          ? this.buttonCtaTextSubscribe || 'Get Started'
          : this.buttonCtaTextOneTime || 'Try Now';
      } else {
        return this.notAvailableButtonText;
      }
    },
    get canShowFullPrice() {
      return (
        this.currentVariant.compareAtPriceInCents &&
        this.currentVariant.compareAtPriceInCents >
        this.currentVariant.priceInCents
      );
    },
    get variantsDiscountedPrice() {
      const prices = {};
      const variants = this.variants;
      variants.map(v => {
        if (
          !v ||
          !this.selectedSellingPlan ||
          (!this.enableSellingPlan && !v.discount) ||
          (this.enableSellingPlan && !v?.sellingPlanAllocations?.length)
        ) {
          return null;
        }

        const planDiscount = v?.sellingPlanAllocations?.find(
          (allocation: { sellingPlanId: number }) => {
            return allocation.sellingPlanId === this.selectedSellingPlan?.id;
          }
        );

        if (planDiscount?.discount) {
          // @ts-ignore
          prices[v.id] = `+ ${planDiscount?.discount}% Off`;
        }
      });

      return prices;
    },
    get canShowFullPriceSubscription() {
      return (
        this.currentVariant.compareAtPriceInCents &&
        this.currentVariant.compareAtPriceInCents >
        this.currentVariant?.sellingPlanAllocations[
          this.selectedSellingPlanIndex
          ]?.priceInCents
      );
    },
    setCurrentImageIndex(index: number) {
      this.currentImageIndex = index;
    },
    setCurrentVariant(id: any) {
      if (this.currentVariantId !== id) {
        this.currentVariantId = id;
        this.carouselImages[0] = this.currentVariant.image;
        this.slider.prev(this.currentImageIndex);
        this.currentImageIndex = 0;

        if (!this.isQuickview) {
          window.history.pushState(
            {},
            '',
            `${window.location.pathname}?variant=${this.currentVariantId}`
          );
        }
      }
    },
    getDiscount(id: any) {
      const variant = this.variants.find((variant: any) => variant.id === id);

      if (
        !variant ||
        (!this.enableSellingPlan && !variant.discount) ||
        (this.enableSellingPlan && !variant?.sellingPlanAllocations?.length)
      ) {
        return null;
      }

      const planDiscount = variant?.sellingPlanAllocations?.filter(
        (allocation: { sellingPlanId: number }) => {
          return allocation.sellingPlanId === this.selectedSellingPlan?.id;
        }
      );

      return `+ ${
        this.enableSellingPlan
          ? variant.sellingPlanAllocations[this.selectedSellingPlanIndex]
            .discount
          : variant.discount
      }% Off`;
    },
    setSelectedSellingPlanId(id: number) {
      if (!id) {
        return false;
      }
      this.enableSellingPlan = true;
      this.selectedSellingPlanInId = id;
      this.selectedSellingPlanIndexLSGPostATC=id;
    },
    async addToCart() {
      if (!this.variants.length) return;


      if (this.currentVariant.available) {
        const properties = {} as { [key: string]: any };

        if (this.variants?.length > 1) {
          properties['_variants'] = JSON.stringify(
            this.variants.map((item: any) => ({
              id: item.id,
              title: item.title,
            }))
          );
        }

        const selectedSellingPlan = this.selectedSellingPlan;

        if (this.enableSellingPlan && selectedSellingPlan) {
          properties['_sellingPlanName'] = `${selectedSellingPlan?.name}`;
          properties['_sellingPlanId'] = `${selectedSellingPlan?.id}`;
        }else{
          this.setShowLSGPostATCModal(true);
        }

        await this.$store.cart.addItem(
          {
            quantity: 1,
            id: this.currentVariant.id,
            ...(this.enableSellingPlan
              ? { selling_plan: selectedSellingPlan?.id }
              : {}),
            properties,
          },
          0 // TODO: Delete this. Free gift handled by Rebuy
        );
        if (this.redirectToCheckout) {
          window.location.href = "/checkout";
          return;
        }
        this.setShowLSGPostATCModal(false);
        if (this.isQuickview) {
          this.close();
        }

        this.$store.ui.toggleCartDrawer(true);
      } else {
        this.$dispatch('open-notify-me-modal', {
          variantId: this.currentVariant.id,
        });
      }
    },
    async checkLoopBundleSellingPlans() {
      const raw = JSON.stringify({
        domain: window.Shopify.shop,
        sellingPlanIds: this.sellingPlanGroups?.flatMap(spg => {
          return spg?.selling_plans?.map(sp => sp.id);
        }),
        product_shopify_id: this.id,
      });

      await fetch(FILTER_BUNDLE_SP_API, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          accept: 'application/json',
        },
        body: raw,
        redirect: 'follow',
      })
        .then(response => response.json())
        .then(result => {
          this.loopBundleSellingPlans = result.data || [];
        })
        .catch(error => console.error(error));
    },
    nextImage() {
      this.currentImageIndex =
        this.carouselImages.length > this.currentImageIndex + 1
          ? this.currentImageIndex + 1
          : 0;
    },
    prevImage() {
      this.currentImageIndex =
        this.currentImageIndex > 0
          ? this.currentImageIndex - 1
          : this.carouselImages.length - 1;
    },
    setSelectedSellingPlanIndexLSGPostATC(index: number) {
      this.selectedSellingPlanIndexLSGPostATC = index;
    },
    addToCartSubLSGOTPPostATC() {
      this.enableSellingPlan = true;
      this.selectedSellingPlanInId = this.selectedSellingPlanIndexLSGPostATC;
      this.addToCart();
    },
    addToCartOTPLSGOTPPostATC() {
      this.enableSellingPlan = false;
      this.redirectToCheckout = true;
      this.addToCart();
    },
    setShowLSGPostATCModal(value: boolean) {
      this.isShowLSGPostATCModal = value;
    }
  }));
};
